import React, { useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { useAppDispatch } from "../../../store/hooks";
import { fetchYoutubeVideos } from "../../../actions/mine_craft/youtubeVideosActions";
import { queryParams } from "../../../helpers/UrlHelpers";

import Wrapper from "../../../componets/Wrapper";
import NavBarThree from "../../../componets/NavBarThree";
import { PlusOutlined } from "@ant-design/icons";
import { setNewParams } from "../../../store/mine_craft/youtubeVideosSlice";
import PageLayout from '../_partials/PageLayout';

import List from "./_partials/_List";
import New from "./New";
import Edit from "./Edit";
import './style.scss';
import PageHeader from "../../../componets/PageHeader";
import SidebarIndex from "./_partials/_SidebarIndex";
import Can from "../../../componets/Can";

const LIMIT = 100;

export interface PropsInterface {
  appId: 1 | 2;
}

const YoutubeVideos = ({ appId }: PropsInterface) => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const currentPage     = queryParams.getInt(searchParams,'page') || 1;

  useEffect(() => {
    const params: any = {
      app_id: appId,
      limit:  LIMIT,
      offset: (currentPage - 1) * LIMIT
    };

    dispatch(fetchYoutubeVideos(params))
  }, [appId, currentPage, dispatch]);

  function onClickCreate() {
    const params: any = { app_id: appId };
    dispatch(setNewParams(params));
  }

  return (
    <PageLayout className='v-youtubeVideos-page'>
      <PageHeader
        title='Youtube Videos'
      />

      <Can capability='write_minecraft'>
        <Wrapper>
          <NavBarThree>
            <NavBarThree.Button className='v-link2' onClick={onClickCreate}>
              <PlusOutlined /> Add Video
            </NavBarThree.Button>
          </NavBarThree>
        </Wrapper>
      </Can>

      <div className='v-container'>
        <List limit={LIMIT} />
      </div>

      <SidebarIndex />

      <New />
      <Edit />
    </PageLayout>
  );
}

export default YoutubeVideos;
